import { createContext, useContext } from 'react';
import type { FollowerAccountDTO, MarketRequestScope } from '@/services/forexApi';

export interface MarketAccountState {
  accounts: FollowerAccountDTO[];
  selectedId: string;
  scope?: MarketRequestScope;
  scopeKey: string;
  loading: boolean;
  error: string;
  select: (id: string) => void;
  refresh: () => void;
}
export const MarketAccountContext = createContext<MarketAccountState | null>(null);

export function useMarketAccount(): MarketAccountState {
  const value = useContext(MarketAccountContext);
  if (!value) throw new Error('MarketAccountProvider required');
  return value;
}
